import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Fade,
  fade,
  Grow,
  IconButton,
  makeStyles,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Fragment, useContext, useEffect, useState } from "react";
import { Bold } from "../../components/UI/TextFormatters";
import { transitionTimeout } from "../ClaimManagement/NewClaimModal/ClaimWizard";
import { separations } from "../../constants/StyleConstants";
import { AttachFile, Close } from "@material-ui/icons";
import DropZone from "../../components/UI/DropZone";
import OutlinedDiv from "../../components/UI/OutlinedDiv";
import { AppContext } from "../../contexts/AppContext";
import clsx from "clsx";
import LinearCompletion from "../../components/UI/LinearCompletion";
import { parseCLDR26 } from "../../utils/GridUtils";
import LimitedBackdrop from "../../components/UI/LimitedBackdrop";

import QualityCertificateRequestsAPI from "../../services/QualityCertificateRequestsAPI";

import { withStyles } from "@material-ui/core/styles";

import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  ...separations,
  root: {
    display: "flex",
    flexDirection: "column",
  },
  supplierChip: {
    margin: 2,
  },
  supplierChipsWrapper: {
    marginTop: 10,
  },
  attachmentInfo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: "1em",
  },
  attachment: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    columnGap: ".5em",
    marginBottom: ".3em",
  },
  attachmentMessage: {
    fontSize: ".8em",
    color: "rgba(0,0,0,.8)",
  },

  dialog: {
    position: "absolute",
    width: "48vw",
    height: "30em",
    transition: ".3s",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  finish: {
    transition: ".7s cubic-bezier(0.15, 0.74, 0.63, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 400,
    height: 200,
    backgroundColor: theme.palette.primary.main,
  },
  finishContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: fade("#FFF", 0.7),
    padding: theme.spacing(1),
  },
  closeButton: {
    transition: ".2s !important",
    position: "absolute",
    top: 0,
    right: 0,
    color: fade("#FFF", 0.3),
    "&:hover": {
      backgroundColor: "transparent",
      color: fade("#FFF", 0.5),
    },
  },
}));

const SuccessDialogBody = ({ onClose }) => {
  const classes = useStyles();
  const [closeFinish, setCloseFinish] = useState(false);

  return (
    <Fragment>
      <Fade in={closeFinish} timeout={700}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </Fade>
      <Grow
        in={true}
        timeout={700}
        style={{ transitionDelay: 300 }}
        onEntered={() => {
          setCloseFinish(true);
        }}
      >
        <div className={classes.finishContent}>
          <Typography align="center" variant="h5">
            Reclamo enviado con éxito
          </Typography>
        </div>
      </Grow>
    </Fragment>
  );
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    marginRight: 35,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const MAX_FILE_SIZE_MB = 50;

const SendingQualityCertificateRequests = ({
  open,
  setOpen,
  selectedRows,
  setSelectedRows,
  reloadGrid,
}) => {
  const classes = useStyles();
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [transIn, setTransIn] = useState(true);
  const [dropZoneTransIn, setDropZoneTransIn] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [remainingFileSpace, setRemainingFileSpace] =
    useState(MAX_FILE_SIZE_MB);

  const [openBackDrop, setOpenBackDrop] = useState(false);

  const [finish, setFinish] = useState(false);

  const onClose = () => {
    setOpen(false);
    finish && reloadGrid();

    setTimeout(() => {
      setAttachedFiles([]);
      setDropZoneTransIn(false);
    }, 500);
  };

  useEffect(() => {
    !open && setAttachedFiles([]);
  }, [open]);

  const confirmRequires = () => {
    setOpenBackDrop(true);

    const ids = selectedRows.map((r) => r.id);
    const formData = new FormData();

    attachedFiles.forEach((file, index) => {
      formData.append("certificates", file);
    });

    formData.append("qualityCertificateId", ids?.join(",") || "");

    return QualityCertificateRequestsAPI.saveCertificate(formData)
      .then((res) => {
        showSuccess("Los certificados se han cargado con éxito");
        setSelectedRows([]);
        reloadGrid();
      })
      .catch((error) => {
        const errorMsg = "Error al realizar las cargas de los certificados";
        showError(errorMsg, error);
        //throw new Error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
  };



  const handleFiles = (files) => {

    if(!attachedFiles.some(f => f.name === files[0].name)){
      setRemainingFileSpace(remainingFileSpace - files[0].size / 1024 / 1024);
      setAttachedFiles([...attachedFiles, files[0]]);
    }
   
    setDropZoneTransIn(false);
  };

  const deleteAttachment = (attachment) => {
    setRemainingFileSpace(remainingFileSpace + attachment.size / 1024 / 1024);
    setAttachedFiles(attachedFiles.filter((file) => file !== attachment));
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = attachedFiles.isEmpty()))
      errorMessages.push("Debe adjuntar al menos un archivo");

    const hasErrors = errors.some((e) => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSend = () => validate() && confirmRequires();

  return (
    <Dialog
      classes={{ paper: clsx(classes.dialog, { [classes.finish]: finish }) }}
      disableBackdropClick={!finish}
      maxWidth="xl"
      open={open}
      onClose={onClose}
    >
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      {finish ? (
        <SuccessDialogBody onClose={onClose} />
      ) : (
        <Fragment>
          <DialogTitle
            id="customized-dialog-title"
            onClose={() => setOpen(false)}
          >
            Carga De Certificados De Calidad
          </DialogTitle>
          <DialogContent style={{ overflowX: "hidden" }} dividers>
            <DropZone
              open={dropZoneTransIn}
              setOpen={setDropZoneTransIn}
              handleFiles={handleFiles}
              maxFileSize={remainingFileSpace}
            >
              <Fade in={transIn} timeout={transitionTimeout}>
                <div className={classes.root}>
                  <div>
                    {!attachedFiles.isEmpty() && (
                      <Fade in={true}>
                        <div className={classes.supplierChipsWrapper}>
                          <OutlinedDiv label="Archivos adjuntos">
                            {attachedFiles.map((att, i) => (
                              <Chip
                                key={i}
                                className={classes.supplierChip}
                                size="small"
                                label={att.name}
                                onDelete={() => deleteAttachment(att)}
                                color="primary"
                              />
                            ))}
                          </OutlinedDiv>
                          <LinearCompletion
                            value={
                              100 -
                              (remainingFileSpace * 100) / MAX_FILE_SIZE_MB
                            }
                            label={
                              (remainingFileSpace < 0.1
                                ? `${Math.trunc(remainingFileSpace * 1024)} KB`
                                : `${parseCLDR26(remainingFileSpace)} MB`) +
                              `/ ${MAX_FILE_SIZE_MB} MB`
                            }
                          />
                        </div>
                      </Fade>
                    )}
                  </div>
                  <div className={classes.attachmentInfo}>

                  <Fade in={true}>
                        <div className={classes.supplierChipsWrapper} style={{ width: '100%'}}>
                          <OutlinedDiv label="Código/s de orden/es de compra/s">
                            {selectedRows.filter((object, index) => 
                              selectedRows.findIndex(item => item.purchaseOrderCode === object.purchaseOrderCode) === index
                            ).map((att, i) => (
                              <Chip
                                key={i}
                                className={classes.supplierChip}
                                size="small"
                                label={att.purchaseOrderCode}
                                //onDelete={() => deleteAttachment(att)}
                                color="primary"
                              />
                            ))}
                          </OutlinedDiv>
                          
                        </div>
                      </Fade>
                    
                    <div className={classes.attachment}>
                      <Tooltip title={"Adjuntar archivo"} enterDelay={1000}>
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<AttachFile />}
                          onClick={() => setDropZoneTransIn(true)}
                        >
                          Adjuntar archivo
                        </Button>
                      </Tooltip>
                      <div className={classes.attachmentMessage}>
                        *Puede adjuntar hasta 50 MB en uno o más archivos
                      </div>
                    </div>
                  </div>
                </div>
              </Fade>
            </DropZone>
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary" onClick={validateAndSend}>
              Aceptar
            </Button>

            <Button autoFocus onClick={onClose} color="secondary">
              Cerrar
            </Button>
          </DialogActions>
        </Fragment>
      )}
    </Dialog>
  );
};

export default SendingQualityCertificateRequests;
